var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:_vm.loading ? 'active' : ''},[_c('no-ssr',[_c('lottie',{staticClass:"animation",attrs:{"options":_vm.defaultOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }